export interface SlashCommand {
  cmd: string;
  args: string;
  hint: string;
}

// A selected command renders as an atomic, highlighted token (like a mention
// chip) in the editor — backspace removes it whole and it reads as a tag.
export const SLASH_TOKEN_CLASS = 'agentforge-slash-token';

// Skill slash commands — typing "/" surfaces these; selecting inserts the
// trigger and the backend's tier-0 router does the rest. Static registry:
// future skills add one entry.
export const SLASH_COMMANDS: SlashCommand[] = [
  {
    cmd: '/marketmap',
    args: '[role, location]',
    hint: 'Map the talent market and build a sourcing plan',
  },
  {
    cmd: '/salarybenchmark',
    args: '[role, location]',
    hint: 'Benchmark market compensation for a role',
  },
];
